import { Button } from 'antd';
import React, { ReactNode } from 'react';
import {
  ErrorBoundary as ReactErrorBoundary,
  FallbackProps,
} from 'react-error-boundary';

const ErrorBoundary = ({
  onError,
  onReset,
  children,
}: {
  onError?: () => void;
  onReset?: () => void;
  children: ReactNode;
}) => {
  const fallbackRender = ({ error, resetErrorBoundary }: FallbackProps) => {
    const handleReset = () => {
      onReset?.();
      resetErrorBoundary();
    };
    return (
      <div className="flex flex-col items-center gap-2">
        <p>Error, please try again later</p>
        <Button type="primary" onClick={handleReset}>
          Try again
        </Button>
      </div>
    );
  };

  const handleOnError = () => {
    onError?.();
  };

  return (
    <ReactErrorBoundary fallbackRender={fallbackRender} onError={handleOnError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
